export default __webpack_public_path__ + "static/media/goldcrestExecutive.fea3a369.png";